define('viewmodels/configuration/RATaxonomySetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils) {
        var ALViewModel = {
            activate: activate,
            attached: attached,
            router: router,
            detached: detached,
            utils: utils,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            ControlsAccess: ko.observable(false),
            objZatList: ko.observableArray([]),
            objZatDropdownList: ko.observableArray([]),
            objRatList: ko.observableArray([]),
            objRatDropdownList: ko.observableArray([]),
            objZatRat_LowestLevelFlag_list: ko.observableArray([]),
            objAllAreaLevelsList: ko.observableArray(),
            SelectedBusinessLevelDetails: ko.observableArray([]),
            editableAreaLevel: ko.observable(),
            addPopUpCss: ko.observable(),
            editPopUpCss: ko.observable(),
            OpenAreaLevelPopup: OpenAreaLevelPopup,
            SelectedALAssessmentType: ko.observableArray([]),
            SelectedALSurveyType: ko.observableArray([]),
            refreshtblALLowestLevel: refreshtblALLowestLevel(),
            ALLowestLevelFlagList: ko.observableArray([]),
            saveTaxonomyLevel: saveTaxonomyLevel,
            eal_name: ko.observable(),
            NavigateToSSRSExportReport: NavigateToSSRSExportReport,
            eal_short_name: ko.observable(),
            eal_description: ko.observable(),
            trclick: trclick,
            currentTarget: ko.observable(),
            selectedEalUid: ko.observable(),
            EALCategoriesList: ko.observableArray([]),
            EALCategoriesListdropdown: ko.observableArray([]),
            EALSubCategoryDetailsList: ko.observableArray([]),
            addSubCategoryDetails: addSubCategoryDetails,
            RiskSubAreaPopUpType: ko.observable(),
            editableRiskSubArea: ko.observable(),
            AssessmentTypeListSubArea: ko.observableArray([]),
            LanguageList: ko.observableArray([]),
            SelectedLanguageQualSubAreaType: ko.observableArray([]),
            SelectedAssessmentTypeSubArea: ko.observable(),
            SelectedAddSubAreaAssessmentType: ko.observableArray([]),
            SelectedZATDropDownListSubArea: ko.observable([]),
            SubAreaPopUpTitle: ko.observable(),
            selectedEalLevel: ko.observable(),
            QualSubAreaLanguageAdded: QualSubAreaLanguageAdded,
            QualRiskSubAreaSubList: ko.observableArray(),
            subcategoryName: ko.observable(),
            subCategoryDesc: ko.observable(),
            saveRiskSubAreaPopUp: saveRiskSubAreaPopUp,
            deleteTaxonomyPopUp: deleteTaxonomyPopUp,
            etl_uid: ko.observable(),
            etl_name: ko.observable(),
            etl_short_name: ko.observable(),
            etl_description: ko.observable(),
            etl_sub_category_name: ko.observable(),
            etl_sub_taxonomy_description: ko.observable(),
            editSubTaxonomyDetails: editSubTaxonomyDetails,
            editFunctionalityTaxonomy: editFunctionalityTaxonomy,
            saveEditFunctionalityTaxonomy: saveEditFunctionalityTaxonomy,
            saveEditSubTaxonomyDetails: saveEditSubTaxonomyDetails,
            etl_mat_id: ko.observable(),
            onChangeAssessmentTypeSubArea: onChangeAssessmentTypeSubArea,
            deleteSubTaxonomyPopUp: deleteSubTaxonomyPopUp,
            deleteSubTaxonomyQuestion: deleteSubTaxonomyQuestion,
            CalculationCheckboxdisabled: ko.observable(),
            LocaleCheckFlag: ko.observable(false),
            CalculationApplicabilityFlag: ko.observable(true)
        };
        return ALViewModel;
        function activate() {
            try {
                if (ALViewModel.ObjGeneralSettings === undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ALViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ALViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ALViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (ALViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() == null || ALViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ALViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ALViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            ALViewModel.LocaleCheckFlag(false);
                        else
                            ALViewModel.LocaleCheckFlag(true);
                    });
                } else
                    ALViewModel.LocaleCheckFlag(true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        };

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                    if (ALViewModel.ObjGeneralSettings === undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ALViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ALViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ALViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (ALViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ALViewModel.ObjGeneralSettings.LocalizedTextList() == null || ALViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ALViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ALViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            ALViewModel.LocaleCheckFlag(false);
                        else
                            ALViewModel.LocaleCheckFlag(true);
                    });
                }

                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            ALViewModel.ControlsAccess(true);
                        }
                        else {
                            ALViewModel.ControlsAccess(false);
                        }
                    });
                }
                else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                    ALViewModel.ControlsAccess(true);
                }
                else {
                    ALViewModel.ControlsAccess(false);
                }
                getZatRatForMapping(0);
                getAllAreaLevels();
                ALViewModel.SelectedALAssessmentType.subscribe(function (newVal) {
                    refreshtblALLowestLevel();
                });
                ALViewModel.SelectedALSurveyType.subscribe(function (newVal) {
                    refreshtblALLowestLevel();
                });
                ALViewModel.SelectedLanguageQualSubAreaType.subscribe(function (newVal) {
                    QualSubAreaLanguageAdded();
                });
                ALViewModel.SelectedAddSubAreaAssessmentType.subscribe(function (newVal) {
                    if (ALViewModel.selectedEalLevel() != 1) {
                        updateSubAreaCategoriesDropdown();
                    }
                });
                ALViewModel.SelectedZATDropDownListSubArea.subscribe(function (newVal) {
                    if (ALViewModel.selectedEalLevel() != 1) {
                        updateSubAreaCategoriesDropdown();
                    }
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function updateSubAreaCategoriesDropdown() {
            try {
                if (ALViewModel.selectedEalLevel() > 1) {
                    var temp = ko.observableArray([]);
                    var SuvComIntersect = ko.observableArray([]);
                    var AssTypeIntersect = ko.observableArray([]);
                    ALViewModel.EALCategoriesListdropdown([]);
                    if (ALViewModel.SelectedAddSubAreaAssessmentType().length > 0 && ALViewModel.SelectedZATDropDownListSubArea().length > 0) {
                        for (var k = 0; k < ALViewModel.EALCategoriesList().length; k++) {
                            var arrAssType = ALViewModel.EALCategoriesList()[k].Rat_ID().split(',');

                            var AssTypeI = arrAssType.filter(function (x) {
                                if (ALViewModel.SelectedAddSubAreaAssessmentType().indexOf(x) > -1)
                                    return x;
                            });
                            if (AssTypeI.length > 0) {
                                for (var l = 0; l < AssTypeI.length; l++) {
                                    AssTypeIntersect.push(AssTypeI[l]);
                                }
                                AssTypeI = null;
                            }

                            if (AssTypeIntersect().length > 0)
                               var arrSurCom = ALViewModel.EALCategoriesList()[k].Zat_ID().split(',');

                            if (arrSurCom == undefined)
                                continue;
                            var SuvComI = arrSurCom.filter(function (x) {
                                if (ALViewModel.SelectedZATDropDownListSubArea().indexOf(x) > -1)
                                    return x;
                            });

                            if (SuvComI.length > 0) {
                                for (var l = 0; l < SuvComI.length; l++)
                                    SuvComIntersect.push(SuvComI[l]);
                                SuvComI = null;
                            }

                            if (AssTypeIntersect().length > 0 && SuvComIntersect().length > 0) {
                                temp.push(ALViewModel.EALCategoriesList()[k]);
                                AssTypeIntersect.removeAll();
                                SuvComIntersect.removeAll();
                            }
                        }
                    }
                    ALViewModel.EALCategoriesListdropdown = temp;

                    ko.cleanNode(document.getElementById('RAApplicability'));
                    ko.applyBindings(ALViewModel, document.getElementById('RAApplicability'));
                    //$('#RAApplicability').multiselect();
                    //$('#RAApplicability').multiselect("refresh");
                    //$("#RAApplicability").val();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: updateSubAreaCategoriesDropdown() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function QualSubAreaLanguageAdded() {
            try {
                var selectedLanguage = ALViewModel.SelectedLanguageQualSubAreaType();
                $('#DynamicQualRiskSubAreaNameDiv').empty();
                var RiskAreaNameHTMl = "";

                $('#DynamicQualRiskSubAreaDescDiv').empty();
                var DescriptionHTMl = "";

                for (var j = 0; j < ALViewModel.SelectedLanguageQualSubAreaType().length; j++) {
                    for (var i = 0; i < ALViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                        if (parseInt(ALViewModel.SelectedLanguageQualSubAreaType()[j]) == ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID()) {
                            RiskAreaNameHTMl += '<div class="new-form-group">' +
                                '<label class="control-label">Name (' + ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                                '<input id="riskareaname' + ALViewModel.SelectedLanguageQualSubAreaType()[j] + '" class="form-control" placeholder="Sub-Category Name in ' + ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" type="text" />' +
                                '</div>';

                            DescriptionHTMl += '<div class="new-form-group">' +
                                '<label class="control-label">Description (' + ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                '<textarea rows="5" id="EditRaTextArea' + ALViewModel.SelectedLanguageQualSubAreaType()[j] + '" class="form-control" placeholder="Sub-Category Description in ' + ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" name="Description" ></textarea>' +
                                '</div>';
                        }
                    }
                }
                document.getElementById('DynamicQualRiskSubAreaNameDiv').innerHTML = RiskAreaNameHTMl;
                ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaNameDiv'));
                ko.applyBindings(ALViewModel, document.getElementById("DynamicQualRiskSubAreaNameDiv"));

                document.getElementById('DynamicQualRiskSubAreaDescDiv').innerHTML = DescriptionHTMl;
                ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaDescDiv'));
                ko.applyBindings(ALViewModel, document.getElementById("DynamicQualRiskSubAreaDescDiv"));

                if (RiskAreaNameHTMl != "" && DescriptionHTMl != "") {
                    $("#frmAreaRiskScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    $("modalContent").css({ "height": "auto", "max-height": "65rem" });
                }
                else
                    $("frmAreaRiskScroll").removeAttr("style");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualSubAreaLanguageAdded() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function NavigateToSSRSExportReport() {
            try {
                var homeurl = homeUrlLocation;
                $('#loadingMainImgDivHm').show();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportTaxonomyReport", payLoad, '_blank');
                $('#loadingMainImgDivHm').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToSSRSExportReport() method in InherentRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function addSubCategoryDetails() {
            
            ALViewModel.subcategoryName("");
            ALViewModel.subCategoryDesc("");
            ALViewModel.CalculationCheckboxdisabled(false);

            $('#valSubCatTaxnmyPopError').hide();
            ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaNameDiv'));
            ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaDescDiv'));
            ALViewModel.ObjGeneralSettings.getLanguages();
            ALViewModel.LanguageList([]);
            for (var i = 0; i < ALViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                if (ALViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() != "English")
                    ALViewModel.LanguageList().push(ALViewModel.ObjGeneralSettings.LanguageList()[i])
            }

            ALViewModel.SelectedLanguageQualSubAreaType([]);
            ko.cleanNode(document.getElementById('RALanguage'));
            ko.applyBindings(ALViewModel, document.getElementById('RALanguage'));
            $('#RALanguage').multiselect();
            $("#RALanguage").val();
            getZatRatForMapping(ALViewModel.selectedEalUid()).then(function op() {
                ALViewModel.SelectedAddSubAreaAssessmentType([]);
                $('#addSubAreaAssessmentType').multiselect();
                $('#addSubAreaAssessmentType').multiselect("refresh");
                $("#addSubAreaAssessmentType").val();
                ALViewModel.SelectedZATDropDownListSubArea([]);
                $('#ZATApplicabilitySubArea').multiselect();
                $('#ZATApplicabilitySubArea').multiselect("refresh");
                $("#ZATApplicabilitySubArea").val();
                ALViewModel.QualRiskSubAreaSubList([]);

                $('#frmRiskSubArea').modal('show');
            });
        }

        function saveRiskSubAreaPopUp() {
            try {
                $('#valSubCatTaxnmyPopError').hide();

                if (undefined === ALViewModel.subcategoryName() || ALViewModel.subcategoryName() == "") {
                    $('#valSubCatTaxnmyPopError').show();
                    $('#valSubCatTaxnmyPopError').text(
                        //'Sub-Category Name is required.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-CategoryNamerequired.') == -1) ? 'Sub-Category Name is required.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-CategoryNamerequired.')].Name())
                    );
                }
                else if (ALViewModel.subcategoryName().length > 100) {
                    $('#valSubCatTaxnmyPopError').show();
                    $('#valSubCatTaxnmyPopError').text(
                        //'Entry Sub-Category Name cannot exceed 100 characters. Please enter a valid one.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EntrySub-CategoryName100characters') == -1) ? 'Entry Sub-Category Name cannot exceed 100 characters. Please enter a valid one.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EntrySub-CategoryName100characters')].Name())
                    );
                }
                else if (undefined === ALViewModel.SelectedAddSubAreaAssessmentType() || ALViewModel.SelectedAddSubAreaAssessmentType().length == 0) {
                    $('#valSubCatTaxnmyPopError').show();
                    $('#valSubCatTaxnmyPopError').text(
                        //'Please select Assessment Type.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectAssessmentType') == -1) ? 'Please select Assessment Type.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectAssessmentType')].Name())
                    );
                }
                else if (undefined === ALViewModel.SelectedZATDropDownListSubArea() || ALViewModel.SelectedZATDropDownListSubArea().length == 0) {
                    $('#valSubCatTaxnmyPopError').show();
                    $('#valSubCatTaxnmyPopError').text(
                        //'Please select Survey Component.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectSurveyComponent') == -1) ? 'Please select Survey Component.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectSurveyComponent')].Name())
                    );
                }
                else if (ALViewModel.selectedEalLevel() != 1 && ALViewModel.SelectedAssessmentTypeSubArea() != undefined && ALViewModel.SelectedAssessmentTypeSubArea().length == 0) {
                    $('#valSubCatTaxnmyPopError').show();
                    $('#valSubCatTaxnmyPopError').text(
                        //'Please select Taxonomy Levels to which the new Sub Cateogry.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectTaxonomyLevels') == -1) ? 'Please select Taxonomy Levels to which the new Sub Cateogry.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectTaxonomyLevels')].Name())
                    );
                }
                else {
                    //3 TVPs and 1 variable
                    //Risk Area Details TVP
                    if (ALViewModel.selectedEalLevel() != 1 && ALViewModel.SelectedAssessmentTypeSubArea() != undefined) {
                        NumberOfRowsInRiskAreaDetailsTvp = ALViewModel.SelectedAddSubAreaAssessmentType().length *
                            ALViewModel.SelectedZATDropDownListSubArea().length * ALViewModel.SelectedAssessmentTypeSubArea().length;
                    }
                    else
                        NumberOfRowsInRiskAreaDetailsTvp = ALViewModel.SelectedAddSubAreaAssessmentType().length *
                            ALViewModel.SelectedZATDropDownListSubArea().length;

                    var RiskAreaDetails = [];

                    for (var i = 0; i < ALViewModel.SelectedAddSubAreaAssessmentType().length; i++) {
                        for (var j = 0; j < ALViewModel.SelectedZATDropDownListSubArea().length; j++) {
                            if (ALViewModel.selectedEalLevel() != 1) {
                                var varAreaType = ALViewModel.objZatList().filter(function (element) {
                                    if (element.zatuid() === ALViewModel.SelectedZATDropDownListSubArea()[j]) {
                                        return element.surveygroup();
                                    }
                                })[0];

                                var row = {
                                    RISK_AREA_NAME: ALViewModel.subcategoryName(),
                                    RISK_AREA_NOTES: ALViewModel.subCategoryDesc(),
                                    RISK_AREA_ASSESSMENT_TYPE: ALViewModel.SelectedAddSubAreaAssessmentType()[i],
                                    RISK_AREA_TYPE: varAreaType.surveygroup(),
                                    PARENT_FLAG: false, //dump any value as this is not used in sproc
                                    ERA_PARENT_ERA_UID: ALViewModel.SelectedAssessmentTypeSubArea(),
                                    CalculationApplicabilityFlag: ALViewModel.CalculationApplicabilityFlag()
                                }
                                RiskAreaDetails.push(row);
                            }
                            else {
                                var varAreaType = ALViewModel.objZatList().filter(function (element) {
                                    if (element.zatuid() === ALViewModel.SelectedZATDropDownListSubArea()[j]) {
                                        return element.surveygroup();
                                    }
                                })[0];
                                var row = {
                                    RISK_AREA_NAME: ALViewModel.subcategoryName(),
                                    RISK_AREA_NOTES: ALViewModel.subCategoryDesc(),
                                    RISK_AREA_ASSESSMENT_TYPE: ALViewModel.SelectedAddSubAreaAssessmentType()[i],
                                    RISK_AREA_TYPE: varAreaType.surveygroup(),
                                    PARENT_FLAG: false, //dump any value as this is not used in sproc
                                    ERA_PARENT_ERA_UID: 0,
                                    CalculationApplicabilityFlag: ALViewModel.CalculationApplicabilityFlag()
                                }
                                RiskAreaDetails.push(row);
                            }
                        }
                    }
                    //ZAT RAT Mapping Tvp

                    var ZatRatParentFlagMapping = [];

                    for (var i = 0; i < ALViewModel.SelectedAddSubAreaAssessmentType().length; i++) {
                        for (var j = 0; j < ALViewModel.SelectedZATDropDownListSubArea().length; j++) {
                            for (var k = 0; k < ALViewModel.objZatRat_LowestLevelFlag_list().length; k++) {
                                if (ALViewModel.SelectedAddSubAreaAssessmentType()[i] === ALViewModel.objZatRat_LowestLevelFlag_list()[k].ratuid()
                                    && ALViewModel.SelectedZATDropDownListSubArea()[j] === ALViewModel.objZatRat_LowestLevelFlag_list()[k].zatuid()
                                ) {
                                    var row = {
                                        TZARAT_ZAT_UID: ALViewModel.objZatRat_LowestLevelFlag_list()[k].zatuid(),
                                        TZARAT_RAT_UID: ALViewModel.objZatRat_LowestLevelFlag_list()[k].ratuid(),
                                        PARENT_FLAG: ALViewModel.objZatRat_LowestLevelFlag_list()[k].LowestLevelFlag() ? false : true
                                    }
                                    ZatRatParentFlagMapping.push(row);
                                }
                            }
                        }
                    }

                    //Language Name and description Tvp

                    var RiskAreaLanguageTvp = [];
                    for (var i = 0; i < ALViewModel.SelectedLanguageQualSubAreaType().length; i++) {
                        selectedItem = ALViewModel.SelectedLanguageQualSubAreaType()[i];
                        riskAreaObj = new RiskArea(selectedItem);
                        for (var j = 0; j < ALViewModel.SelectedZATDropDownListSubArea().length; j++) {
                            var varAreaType = ALViewModel.objZatList().filter(function (element) {
                                if (element.zatuid() === ALViewModel.SelectedZATDropDownListSubArea()[j]) {
                                    return element.surveygroup();
                                }
                            })[0];
                            var row = {
                                RISK_AREA_NAME: ALViewModel.subcategoryName(),
                                RISK_AREA_TYPE: varAreaType.surveygroup(),
                                RISK_LANGUAGE_AREA_NAME: riskAreaObj.RiskAreaName,
                                RISK_LANGUAGE_AREA_NOTES: riskAreaObj.RiskAreaNotes,
                                RISK_LANGUAGE_AREA_LANGUAGETYPE: riskAreaObj.LanguageType
                            }
                            RiskAreaLanguageTvp.push(row);
                        }
                    }

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/Configuration/SaveSubCategoryDetails",
                        type: "POST",
                        headers: headers,
                        data: {
                            eal_uid: ALViewModel.selectedEalUid(),
                            zat_tvp: ZatRatParentFlagMapping,
                            subcat_details_tvp: RiskAreaDetails,
                            subcat_lang_tvp: RiskAreaLanguageTvp,
                            CalculationApplicabilityFlag: RiskAreaDetails[0].CalculationApplicabilityFlag
                        }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveRiskSubAreaPopUp() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (null == result || result == 0 || result < 0) {
                            $($('#tblAreaLevels tbody .details-control').get(ALViewModel.currentTarget())).trigger('click');
                            $($('#tblAreaLevels tbody .details-control').get(ALViewModel.currentTarget())).trigger('click');
                            logger.logError(
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewSub-Categoryadderror') == -1) ? 'An error occurred while adding new Sub-Category. Please contact your Administrator.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewSub-Categoryadderror')].Name())
                                , 'Error', system.getModuleId(ALViewModel), true);
                        }
                        else if (result > 0) {
                            $('#frmRiskSubArea').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            logger.logSuccess(
                                //'New Sub-Category added successfully.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewSub-Categoryaddsuccess') == -1) ? 'New Sub-Category added successfully.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewSub-Categoryaddsuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                            getAllAreaLevels();
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in saveRiskSubAreaPopUp() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in saveRiskSubAreaPopUp() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in saveRiskSubAreaPopUp() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function RiskArea(item) {
            try {
                var self = this;
                self.RiskAreaName = $('#riskareaname' + item).val();
                self.RiskAreaNotes = $('#EditRaTextArea' + item).val();
                self.LanguageType = item;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskArea() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        };
        function refreshtblALLowestLevel() {
            if (null != ALViewModel && null != ALViewModel.SelectedALAssessmentType && null != ALViewModel.SelectedALSurveyType) {
                if (ALViewModel.SelectedALAssessmentType().length > 0 && ALViewModel.SelectedALSurveyType().length > 0) {
                    var objrows = [];
                    var objrow = {};
                    var totalrows = ALViewModel.SelectedALAssessmentType().length * ALViewModel.SelectedALSurveyType().length;
                    for (var i = 0; i < totalrows; i++) //increment selected AT
                    {
                        for (var k = 0; k < ALViewModel.objRatList().length; k++) {
                            if (ALViewModel.objRatList()[k].ratuid() == ALViewModel.SelectedALAssessmentType()[i]) {
                                for (var l = 0; l < ALViewModel.SelectedALSurveyType().length; l++) {
                                    for (var m = 0; m < ALViewModel.objZatList().length; m++) {
                                        if (ALViewModel.objZatList()[m].zatuid() == ALViewModel.SelectedALSurveyType()[l]) {
                                            var objrow = {};
                                            objrow.ratuid = ALViewModel.objRatList()[k].ratuid();
                                            objrow.ratname = ALViewModel.objRatList()[k].ratname();
                                            objrow.zatuid = ALViewModel.objZatList()[m].zatuid();
                                            objrow.zatname = ALViewModel.objZatList()[m].zatname();
                                            var objrowconcat = objrow.ratuid + '|' + objrow.zatuid;
                                            var rowexists = false;
                                            var rowflag = false;
                                            for (var n = 0; n < ALViewModel.objZatRat_LowestLevelFlag_list().length; n++) {
                                                var objexistingLowestFlagConcat = ALViewModel.objZatRat_LowestLevelFlag_list()[n].ratuid() + '|' + ALViewModel.objZatRat_LowestLevelFlag_list()[n].zatuid();
                                                if (objrowconcat === objexistingLowestFlagConcat && ALViewModel.objZatRat_LowestLevelFlag_list()[n].LowestLevelFlag() === "true") {
                                                    rowexists = true;
                                                    break;
                                                }
                                                if (objrowconcat == objexistingLowestFlagConcat) {
                                                    rowflag = true;
                                                    break;
                                                }
                                                else {
                                                    rowflag = false;
                                                }
                                            }
                                            if (!rowexists && rowflag == true) {
                                                objrows.push(objrow);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    var mappedLowestLevelList = $.map(objrows, function (result) {
                        return new ALLowestLevelModel(result);
                    });
                    tableObj = $('#tblALLowestLevel').DataTable();
                    tableObj.destroy();
                    $('#tblALLowestLevel tbody tr').remove();
                    ALViewModel.ALLowestLevelFlagList([]);
                    ALViewModel.ALLowestLevelFlagList(mappedLowestLevelList);
                    $('#tblALLowestLevel').DataTable({
                        "language": {
                            "emptyTable": "Selected Lowest Level(s) already exists"
                        }
                    }).draw(false);
                }
                else {
                    tableObj = $('#tblALLowestLevel').DataTable();
                    tableObj.destroy();
                    $('#tblALLowestLevel tbody tr').remove();
                    ALViewModel.ALLowestLevelFlagList([]);
                    $('#tblALLowestLevel').DataTable().draw(false);
                }
            }
        }

        function getAllAreaLevels() {
            try {
                $.ajax({
                    url: "/api/configuration/GetAllAreaLevels",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getAllAreaLevels() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                        logger.logError(jsonResult[0].ErrorName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult.length > 0) {
                        var MappedAllAreaLevelsModelList = $.map(jsonResult, function (result) {
                            return new AllAreaLevelModel(result);
                        });
                        ALViewModel.objAllAreaLevelsList(MappedAllAreaLevelsModelList);
                        for (var i = 0, j = ALViewModel.objAllAreaLevelsList().length; i < j; i++) {
                            GetFactorTabData(ALViewModel.objAllAreaLevelsList()[i]);
                        }
                        ALTableObj = $('#tblAreaLevels').DataTable();
                        ALTableObj.destroy();
                        $("#tblAreaLevels tbody tr").remove();
                        ALViewModel.objAllAreaLevelsList(MappedAllAreaLevelsModelList);
                        for (var i = 0, j = ALViewModel.objAllAreaLevelsList().length; i < j; i++) {
                            GetFactorTabData(ALViewModel.objAllAreaLevelsList()[i]);
                        }
                        ALTableObj = $('#tblAreaLevels').DataTable({
                            "bResponsive": true,
                            "stateSave": true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "bSortable": false,

                                "sClass": "details-control"
                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [2],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [3],
                                "bVisible": true
                            },
                            {
                                "aTargets": [4],
                                "bVisible": true
                            },
                            {
                                "aTargets": [5],
                                "bVisible": true
                            },
                            {
                                "aTargets": [6],
                                "bVisible": true
                            },
                            {
                                "aTargets": [7],
                                "bVisible": true
                            },
                            {
                                "aTargets": [8],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": true
                            }]
                        });

                        $('#tblAreaLevels').DataTable().draw(false);
                    }
                    else {
                        ALViewModel.objAllAreaLevelsList([]);
                        GetFactorTabData(ALViewModel.objAllAreaLevelsList([]));
                        ALTableObj = $('#tblAreaLevels').DataTable({
                            "bResponsive": true,
                            "stateSave": true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "bSortable": false,

                                "sClass": "details-control"
                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [2],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [3],
                                "bVisible": true
                            },
                            {
                                "aTargets": [4],
                                "bVisible": true
                            },
                            {
                                "aTargets": [5],
                                "bVisible": true
                            },
                            {
                                "aTargets": [6],
                                "bVisible": true
                            },
                            {
                                "aTargets": [7],
                                "bVisible": true
                            },
                            {
                                "aTargets": [9],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": false
                            }]
                        });
                        $('#tblAreaLevels').DataTable().draw(false);
                    }

                    ko.applyBindingsToNode($('#tblAreaLevels tbody .details-control'), { click: ALViewModel.trclick }, ALViewModel);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllAreaLevels() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in getAllAreaLevels() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllAreaLevels() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function trclick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = ALTableObj.row($(event.currentTarget).closest('tr'));
                ALViewModel.currentTarget($(event.currentTarget).closest('tr').get(0)._DT_RowIndex);
                checkExpandedRow(row, false);
                ALViewModel.selectedEalUid(row.data()[1]);
                ALViewModel.selectedEalLevel(row.data()[2]);
                ALViewModel.SubAreaPopUpTitle("Add Taxonomy Details for " + row.data()[3]);

                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    getEalCategories();
                    GetAllSubCategoriesDetails().then(function () {

                        let titleEdit = (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton') == -1) ? 'Edit' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton')].Name();
                        let titleDelete = (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name();
                        let titleAddEntry = (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewEntry') == -1) ? 'click to add new Entry' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewEntry')].Name();

                        var SfHtml = '<div class="child-active ml-1">' +
                            '<div class="panel panel-success panel-margin">' +
                            '<div class="panel-heading">' +
                            '<h5 class="panel-title riskFactorCellPanel text-left">';
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubCategoryLevels') == -1) ? 'Sub Category Levels' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubCategoryLevels')].Name();
                        //Sub Category Levels';
                        if (ALViewModel.ControlsAccess()) {
                            SfHtml += '<button id="addSubFactorBtn" class="primary-btn pull-right" style="margin-top:-15px;" data-bind="click: $root.addSubCategoryDetails" title="' + titleAddEntry + '">' +
                                '<i class="fa fa-plus"></i>';
                            //Add Taxonomy Details'
                            SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddTaxonomyDetails') == -1) ? 'Add Taxonomy Details' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddTaxonomyDetails')].Name();
                            SfHtml += '</button>';
                        }
                        SfHtml += '</h5>';
                        SfHtml += '</div>';
                        SfHtml += '</div>';
                        SfHtml += '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">';
                        SfHtml += '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">';
                        SfHtml += '<thead>';
                        SfHtml += '<tr>';
                        SfHtml += '<th style="display:none">MAT UID</th>';
                        SfHtml += '<th class="w-5">'
                        //Sub - Category Name
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-CategoryName') == -1) ? 'Sub-Category Name' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-CategoryName')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th class="w-50">';
                        //Description'
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description') == -1) ? 'Description' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th style="display:none">Assessment Type Ids</th>';
                        SfHtml += '<th>';
                        //Assessment Type
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType') == -1) ? 'Assessment Type' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th class="w-20" style="display:none">Survey Component Ids</th>';
                        SfHtml += '<th>';
                        //Survey Component
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyComponent') == -1) ? 'Survey Component' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyComponent')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th style="display:none">Mapped To Ids</th>';
                        SfHtml += '<th>';
                        //Mapped To
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappedTo') == -1) ? 'Mapped To' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappedTo')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th class="actions text-center">';
                        //Calculation Applicability
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability') == -1) ? 'Calculation Applicability' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '<th class="actions text-center">';
                        //Actions
                        SfHtml += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();
                        SfHtml += '</th > ';
                        SfHtml += '</tr>';
                        SfHtml += '</thead>';
                        SfHtml += '<tbody data-bind="foreach: EALSubCategoryDetailsList">';
                        SfHtml += '<tr>';
                        SfHtml += '<td style="display:none" data-bind="text: Mat_UID"></td>';
                        SfHtml += '<td class="text-left" data-bind="text: Mat_Name"></td>';
                        SfHtml += '<td class="text-left" data-bind="text: MAT_DESCRIPTION"></td>';
                        SfHtml += '<td style="display:none" data-bind="text: APPLICABILE_IDS"></td>';
                        SfHtml += '<td class="text-left" data-bind="text: APPLICABILITY"></td>';
                        SfHtml += '<td style="display:none" data-bind="text: ZAT_IDS"></td>';
                        SfHtml += '<td class="text-left" data-bind="text: ZAT_NAMES"></td>';
                        SfHtml += '<td style="display:none" data-bind="text: PARENT_AREA_IDS"></td>';
                        SfHtml += '<td class="text-left" data-bind="text: PARENT_AREA_NAMES"></td>';
                        SfHtml += '<td class="text-left" data-bind="html: ApplicabilityFlag"></td>';
                        SfHtml += '<td class="text-center">';
                        SfHtml += '<!-- ko if: $root.ControlsAccess()-->';
                        SfHtml += '<a href="javascript:void(0)" title="' + titleEdit + '" class="btn-borderless widget-button" data-bind="click: $root.editSubTaxonomyDetails, css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">';
                        SfHtml += '<i class="demo-icon icon-file_edit_special"></i>';
                        SfHtml += '</a>';
                        SfHtml += '<a href="javascript:void(0)" title="' + titleDelete + ' " class="btn-borderless widget-button" data-bind="click: $root.deleteSubTaxonomyPopUp, css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">';
                        SfHtml += '<i class="demo-icon icon-bin_special"></i>';
                        SfHtml += '</a>';
                        SfHtml += '<!--/ko-->';
                        SfHtml += '</td>';
                        SfHtml += '</tr>';
                        SfHtml += '</tbody>';
                        SfHtml += '</table>';
                        SfHtml += '</div>';

                        row.child(SfHtml).show();
                        tr.addClass('shown');
                        ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: ALViewModel.EALSubCategoryDetailsList }, ALViewModel);
                        ko.applyBindingsToNode($('#addSubFactorBtn'), { disabled: true, click: ALViewModel.addSubCategoryDetails }, ALViewModel);
                        RfSubFactorTableObj = $("#subfactor").DataTable({
                            "bInfo": true,
                            "bResponsive": true,
                            "stateSave": true,
                            "bPaginate": true,
                            "aaSorting": [],
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": false,
                                "bSortable": false
                            }, {
                                "aTargets": [1],
                                "bSortable": false
                            },
                            {
                                "aTargets": [2],
                                "bSortable": false
                            },
                            {
                                "aTargets": [3],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [4],
                                "bSortable": false
                            },
                            {
                                "aTargets": [5],
                                "bVisible": false,
                                "bSortable": false
                            },
                            {
                                "aTargets": [6],
                                "bSortable": false
                            },
                            {
                                "aTargets": [7],
                                "bVisible": false,
                                "bSortable": false
                            },

                            {
                                "aTargets": [8],
                                "bSortable": false
                            },
                            {
                                "aTargets": [9],
                                "bSortable": false
                            },
                            {
                                "aTargets": [10],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": true
                            }]
                        });
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: trclick() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#tblAreaLevels').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = ALTableObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    var tr = $('#tblAreaLevels').find('tr').get(i);
                    if (ALTableObj.row(tr).index() != row.index()) {
                        var tableRowIndex = (info.page * info.length) + (i - 1);

                        if ((ALTableObj.row(tableRowIndex).child() != undefined) && (ALTableObj.row(tableRowIndex).child.isShown())) {
                            ALTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown')
                            j = $('#tblAreaLevels').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function GetAllSubCategoriesDetails() {
            try {
                ALViewModel.EALCategoriesList([]);
                return $.ajax({
                    url: "/api/configuration/GetAllSubCategoriesDetails?eal_uid=" + ALViewModel.selectedEalUid(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (result, status) {
                        if (result != null && result.length > 0 && result[0].ErrorId == -99) {
                            logger.logError(result[0].ErrorName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                        }
                        else if (null != result) {
                            if (result.length > 0) {
                                var mappedEALCategoryDetails = $.map(result, function (result) {
                                    return new EalSubCategoryDetailsModel(result);
                                });
                                ALViewModel.EALSubCategoryDetailsList(mappedEALCategoryDetails);
                            }
                            else {
                                ALViewModel.EALSubCategoryDetailsList([]);
                            }
                        }
                    })
                    .fail(function (result, status) {
                        if (error.status == 401) {
                            app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in get Sub Category Details.", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        } else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in GetAllSubCategoriesDetails() method in RATaxonomySetup.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllSubCategoriesDetails() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }

        function getEalCategories() {
            try {
                ALViewModel.EALCategoriesList([]);
                $.ajax({
                    url: "/api/configuration/GetAllSubCategoriesHeaders?eal_uid=" + ALViewModel.selectedEalUid(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getEalCategories() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.length > 0 && result[0].ErrorId == -99) {
                        logger.logError(result[0].ErrorName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else if (null != result) {
                        if (result.length > 0) {
                            var mappedEALCategories = $.map(result, function (result) {
                                return new EalCategoryModel(result);
                            });
                            ALViewModel.EALCategoriesList(mappedEALCategories);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getEalCategories() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in get Sub Category Headers.", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in getEalCategories() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getEalCategories() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        function GetFactorTabData(data) {
            try {
                let titleEdit = (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton') == -1) ? 'Edit' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton')].Name();
                let titleDelete = (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name();

                var HtmlBody = '<table id="tblAreaLevels" class="dataTable table-bordered no-footer" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th class="site_name"></th>' +
                    '<th class="site_name" style="display:none" >Area Level Id</th>' +
                    '<th class="site_name" style="display:none" >';

                //Area Level
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreaLevel') == -1) ? 'Area Level' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreaLevel')].Name();
                HtmlBody += '</th > ' +
                    '<th class="site_name">'
                //Taxonomy Level Name
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelName') == -1) ? 'Taxonomy Level Name' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelName')].Name();
                HtmlBody += '</th > ' +
                    '<th class="site_name">';
                //Short Name
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName') == -1) ? 'Short Name' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName')].Name();
                HtmlBody += '</th > ' +
                    '<th class="site_name">';
                //Description
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description') == -1) ? 'Description' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description')].Name();
                HtmlBody += '</th > ' +
                    '<th class="site_name">'

                //Assessment Type
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType') == -1) ? 'Assessment Type' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType')].Name();
                HtmlBody += '</th > ' +
                    '<th class="site_name">'
                //Survey Component
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyComponent') == -1) ? 'Survey Component' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyComponent')].Name();
                HtmlBody += '</th > ' +
                    '<th class="parent_action text-center">'
                HtmlBody += (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();
                //Actions
                HtmlBody += '</th > ' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: objAllAreaLevelsList">' +
                    '<tr>' +
                    '<td class="details-control action-bgcolor"><div style="display:none"></div></td>' +
                    '<td style="display:none" data-bind="text: eal_uid"></td>' +
                    '<td style="display:none" data-bind="text: eal_level"></td>' +
                    '<td class="text-left" data-bind="text: eal_name"></td>' +
                    '<td class="text-left" data-bind="text: eal_short_name"></td>' +
                    '<td class="text-left" data-bind="text: eal_description"></td>' +
                    '<td class="text-left" data-bind="text: eal_rat_names"></td>' +
                    '<td class="text-left" data-bind="text: eal_zat_names"></td>' +
                    '<td class="text-center action-bgcolor">' +
                    '<!-- ko if: $root.ControlsAccess()-->' +
                    '<a href="javascript:void(0)" title="' + titleEdit + '" class="btn-borderless widget-button" data-bind="click:$root.editFunctionalityTaxonomy,css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" title="' + titleDelete + '" class="btn-borderless widget-button" data-bind="click: $root.deleteTaxonomyPopUp, css: { "disabled": (!$root.appsecurity.finalConfigurationSave()) } ">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</a>' +
                    '<!--/ko-->' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>';
                document.getElementById('adddivtabbody').innerHTML = HtmlBody;
                ko.applyBindingsToNode($('#tblAreaLevels').find('tbody').get(0), { foreach: ALViewModel.objAllAreaLevelsList }, ALViewModel);
                var selected = new AllAreaLevelModel({ eal_uid: data.eal_uid(), eal_name: data.eal_name() });
                ALViewModel.SelectedBusinessLevelDetails(selected);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function editFunctionalityTaxonomy(data, event) {
            var row = $(event.currentTarget).closest('tr').get(0);
            ALViewModel.etl_uid(data.eal_uid());
            ALViewModel.etl_name(data.eal_name());
            ALViewModel.etl_short_name(data.eal_short_name());
            ALViewModel.etl_description(data.eal_description());
            //ALViewModel.CalculationApplicabilityFlag(data.CalculationApplicabilityFlag());

            $('#frmEditTaxonomyLevel').modal('show');
        }

        function saveEditFunctionalityTaxonomy() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/UpdateTaxonomyCell",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        eal_uid: ALViewModel.etl_uid(),
                        eal_name: ALViewModel.etl_name(),
                        eal_short_name: ALViewModel.etl_short_name(),
                        eal_description: ALViewModel.etl_description()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveEditFunctionalityTaxonomy() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else if (result == "0" || parseInt(result) < 0) {
                        // Log Error
                        var msg = ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelupdateerror') == -1) ? 'Taxonomy Level Could not be updated' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelupdateerror')].Name());
                        ////'Taxonomy Level Could not be updated';
                        logger.logError(msg, 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (result == "1") {
                            $('#frmEditTaxonomyLevel').modal('hide');
                            $('body').removeClass('modal-open');

                            getAllAreaLevels();
                            logger.logSuccess(
                                //'Taxonomy Level edited successfully.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveleditsuccess') == -1) ? 'Taxonomy Level edited successfully.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveleditsuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);

                            //Success Message and pop hide
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in saveEditFunctionalityTaxonomy() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in saveEditFunctionalityTaxonomy() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in saveEditFunctionalityTaxonomy() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function editSubTaxonomyDetails(data, event) {
            try {

                var row = $(event.currentTarget).closest('tr').get(0);
                ALViewModel.etl_mat_id(data.Mat_UID());
                ALViewModel.etl_sub_category_name(data.Mat_Name());
                ALViewModel.etl_sub_taxonomy_description(data.MAT_DESCRIPTION());
                ALViewModel.CalculationApplicabilityFlag(data.CalculationApplicabilityFlag());
                //ALViewModel.CalculationCheckboxdisabled(false);

                $('#frmEditTaxonomyLevelDetails').modal('show');
                $('#modalContentFactor').css({
                    'margin-top': '30%'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editSubTaxonomyDetails() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }

        function saveEditSubTaxonomyDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/UpdateSubTaxonomyCell",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Mat_UID: parseInt(ALViewModel.etl_mat_id()),
                        Mat_Name: ALViewModel.etl_sub_category_name(),
                        MAT_Description: ALViewModel.etl_sub_taxonomy_description(),
                        CalculationApplicabilityFlag: ALViewModel.CalculationApplicabilityFlag()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveEditSubTaxonomyDetails() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (result == "1") {
                            $('#frmEditTaxonomyLevelDetails').modal('hide');
                            $('body').removeClass('modal-open');
                            GetAllSubCategoriesDetails();
                            logger.logSuccess(
                                //'Taxonomy Level edited successfully.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveleditsuccess') == -1) ? 'Taxonomy Level edited successfully.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveleditsuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                        }

                        if (result == "0" || parseInt(result) < 0) {
                            // Log Error
                            var msg = ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelupdateerror') == -1) ? 'Taxonomy Level Could not be updated' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelupdateerror')].Name());
                            ////'Taxonomy Level Could not be updated';

                            logger.logError(msg, 'Error', system.getModuleId(ALViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in saveEditSubTaxonomyDetails() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in saveEditSubTaxonomyDetails() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in saveEditSubTaxonomyDetails() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function deleteTaxonomyPopUp(data, event) {
            try {
                app.showMessage(
                    //'Are you sure you want to delete this?'
                    ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete') == -1) ? 'Are you sure you want to delete this?' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete')].Name())
                    , ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteTaxonomyQuestion') == -1) ? 'Delete Taxonomy Question' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteTaxonomyQuestion')].Name()),
                    [
                        //'Confirm'
                        (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()
                        ,
                        //'Cancel'
                        (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name()
                    ])
                    .then(function (option) {
                        if (option === ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name())) {
                            deleteTaxonomyQuestion(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteTaxonomyPopUp() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }

        function deleteSubTaxonomyPopUp(data, evvent) {
            try {
                app.showMessage(
                    //'Are you sure you want to delete this?'
                    ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete') == -1) ? 'Are you sure you want to delete this?' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete')].Name())
                    , ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteTaxonomyQuestion') == -1) ? 'Delete Taxonomy Question' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteTaxonomyQuestion')].Name())
                    , [
                        //'Confirm'
                        (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()
                        ,
                        //'Cancel'
                        (!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name()
                    ])
                    .then(function (option) {
                        if (option === ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name())) {
                            deleteSubTaxonomyQuestion(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteSubTaxonomyPopUp() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }

        function deleteTaxonomyQuestion(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/DeleteTaxonomyLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        eal_uid: data.eal_uid(),
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteTaxonomyQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (parseInt(result) >= 1) {
                            getAllAreaLevels();
                            logger.logSuccess(
                                //'Taxonomy Level successfully Deleted.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDeleteSuccess') == -1) ? 'Taxonomy Level successfully Deleted.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDeleteSuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                            //Success Message and pop hide
                        }

                        if (result == "0") {
                            // Log Error
                            logger.logWarning(
                                //'The taxonomy level has dependencies. Please contact the Administrator'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDependency') == -1) ? 'The taxonomy level has dependencies. Please contact the Administrator' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDependency')].Name())
                                , 'Warning', system.getModuleId(ALViewModel), true);
                        }

                        if (parseInt(result) < 0) {
                            // Log Error
                            logger.logError(
                                //'An error occurred while deleting the Taxonomy Level. Please contact your Administrator.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDeleteError') == -1) ? 'An error occurred while deleting the Taxonomy Level. Please contact your Administrator' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLevelDeleteError')].Name()), 'Error', system.getModuleId(ALViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteTaxonomyQuestion() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else
                    {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteTaxonomyQuestion() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e)
                {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteTaxonomyQuestion() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function deleteSubTaxonomyQuestion(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/DeleteSubTaxonomyLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Mat_uid: data.Mat_UID(),
                        ZAT_ID: data.ZAT_IDS()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteSubTaxonomyQuestion() method in RATaxonomy.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (result == "1") {
                            getAllAreaLevels();
                            //GetAllSubCategoriesDetails();
                            logger.logSuccess(
                                //'Sub Taxonomy Level successfully Deleted.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelSuccess') == -1) ? 'Sub Taxonomy Level successfully Deleted.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelSuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                            //Success Message and pop hide
                        }

                        if (result == "0") {
                            // Log Error
                            logger.logWarning(
                                //'The taxonomy sub level has dependencies. Please contact the Administrator'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelDependency') == -1) ? 'The taxonomy sub level has dependencies. Please contact the Administrator' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelDependency')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                        }

                        if (parseInt(result) < 0) {
                            // Log Error

                            logger.logError(
                                //'An error occurred while deleting the SubTaxonomy Level. Please contact your Administrator.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelDeleteError') == -1) ? 'An error occurred while deleting the SubTaxonomy Level. Please contact your Administrator.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubTaxonomyLevelDeleteError')].Name())
                                , 'Error', system.getModuleId(ALViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteSubTaxonomyQuestion() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteSubTaxonomyQuestion() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteSubTaxonomyQuestion() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function getZatRatForMapping(param_eal_uid) {
            try {
                return $.ajax({
                    url: "/api/configuration/GetZatRatForMapping",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { eal_uid: param_eal_uid }

                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getZatRatForMapping() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.ErrorId == -99) {
                        logger.logError(result.ErrorName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (null != result.AL_ZAT_LIST) {
                            ALViewModel.objZatList($.map(result.AL_ZAT_LIST, function (result) {
                                return new ZAT_List_Model(result);
                            }));
                        }
                        if (null != result.AL_RAT_LIST) {
                            ALViewModel.objRatList($.map(result.AL_RAT_LIST, function (result) {
                                return new RAT_List_Model(result);
                            }));
                        }
                        if (null != result.AL_AL_RAT_ZAT_LowestLevel_LIST) {
                            ALViewModel.objZatRat_LowestLevelFlag_list($.map(result.AL_AL_RAT_ZAT_LowestLevel_LIST, function (result) {
                                return new ZATRAT_LowestLevel_Model(result);
                            }));
                        }
                    }

                    }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getZatRatForMapping() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in getZatRatForMapping() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getZatRatForMapping() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        function OpenAreaLevelPopup() {
            try {
                ALViewModel.eal_name("");
                ALViewModel.eal_short_name("");
                ALViewModel.eal_description("");
                var newAL = new AllAreaLevelModel({ eal_uid: 999, eal_name: "", eal_description: "", eal_short_name: "" });
                ALViewModel.editableAreaLevel(newAL);
                ALViewModel.addPopUpCss(true);
                getZatRatForMapping(0).then(function op() {
                    $('#frmAreaLevels').modal('show');
                    isEdit = false;
                    setTimeout("$('#FirstInputpopup').focus();", 200);
                    ALViewModel.SelectedALAssessmentType([]);
                    ALViewModel.SelectedALSurveyType([]);
                    $("#addALAssessmentType").multiselect();
                    $("#addALAssessmentType").val();
                    $("#addALSurveyType").multiselect();
                    $("#addALSurveyType").val();
                    $('#tblALLowestLevel').DataTable().draw(false);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenAreaLevelPopup() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function saveTaxonomyLevel() {
            try {
                $('#valALTaxnmyPopError').hidesaveTaxonomyLevel

                if (undefined === ALViewModel.eal_name() || ALViewModel.eal_name() == "") {
                    $('#valALTaxnmyPopError').show();
                    $('#valALTaxnmyPopError').text(
                        //'Name is required.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq') == -1) ? 'Name is required.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq')].Name())
                    );
                }
                else if (ALViewModel.eal_name().length > 100) {
                    $('#valALTaxnmyPopError').show();
                    $('#valALTaxnmyPopError').text(
                        //'Entry name cannot exceed 100 characters. Please enter a valid one.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EntryNameExceeds100Chars') == -1) ? 'Entry name cannot exceed 100 characters. Please enter a valid one.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EntryNameExceeds100Chars')].Name())
                    );
                }
                else if (undefined === ALViewModel.eal_short_name() || ALViewModel.eal_short_name() == "") {
                    $('#valALTaxnmyPopError').show();
                    $('#valALTaxnmyPopError').text(
                        //'Short Name is required.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortNameRequired') == -1) ? 'Short Name is required.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortNameRequired')].Name())
                    );
                }
                else if (undefined === ALViewModel.SelectedALAssessmentType() || ALViewModel.SelectedALAssessmentType().length == 0) {
                    $('#valALTaxnmyPopError').show();
                    $('#valALTaxnmyPopError').text(
                        //'Please select Assessment Type.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectAssessmentType') == -1) ? 'Please select Assessment Type.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectAssessmentType')].Name())
                    );
                }
                else if (undefined === ALViewModel.SelectedALSurveyType() || ALViewModel.SelectedALSurveyType().length == 0) {
                    $('#valALTaxnmyPopError').show();
                    $('#valALTaxnmyPopError').text(
                        //'Please select Survey Component.'
                        ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectSurveyComponent') == -1) ? 'Please select Survey Component.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('PleaseSelectSurveyComponent')].Name())
                    );
                }
                else {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    var objlowestlevelMapping = $.map(ALViewModel.ALLowestLevelFlagList(), function (result) {
                        return new TvpLowestLevelModel(result);
                    });
                    $.ajax({
                        url: "/api/Configuration/SaveTaxonomyLevel",
                        type: "POST",
                        headers: headers,
                        data: { LevelName: ALViewModel.eal_name(), ShortName: ALViewModel.eal_short_name(), Desc: ALViewModel.eal_description(), LowestLevelMappingobj: objlowestlevelMapping }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveTaxonomyLevel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result != null && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ALViewModel), true);
                    }
                    else {
                        if (null == result || result == "0" || parseInt(result) < 0) {
                            logger.logError(
                                //'An error occurred while adding New Taxonomy Level. Please contact your Administrator.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveladderror') == -1) ? 'An error occurred while adding New Taxonomy Level. Please contact your Administrator.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveladderror')].Name())
                                , 'Error', system.getModuleId(ALViewModel), true);
                        }
                        else if (result == "2") {
                            logger.logError(
                                //'Lowest Taxonomy Level has already been configured.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LowestTaxonomyLevelalreadyconfigured') == -1) ? 'Lowest Taxonomy Level has already been configured.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LowestTaxonomyLevelalreadyconfigured')].Name())
                                , 'Error', system.getModuleId(ALViewModel), true);
                        }
                        else {
                            $('#frmAreaLevels').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            logger.logSuccess(
                                //'New Taxonomy Level added successfully.'
                                ((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveladdsuccess') == -1) ? 'New Taxonomy Level added successfully.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TaxonomyLeveladdsuccess')].Name())
                                , 'Success', system.getModuleId(ALViewModel), true);
                            getAllAreaLevels();
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getZatRatForMapping() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!ALViewModel.LocaleCheckFlag() || ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ALViewModel.ObjGeneralSettings.LocalizedTextList()[ALViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    } else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in getZatRatForMapping() method in RATaxonomySetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getZatRatForMapping() method in RATaxonomySetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ZAT_List_Model(item) {
            try {
                var self = this;
                self.zatuid = ko.observable($('<div/>').html(item.ZAT_UID).text());
                self.zatname = ko.observable($('<div/>').html(item.ZAT_Name).text());
                self.surveygroup = ko.observable($('<div/>').html(item.Survey_group).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ZAT_List_Model() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function RAT_List_Model(item) {
            try {
                var self = this;
                self.ratuid = ko.observable($('<div/>').html(item.RAT_UID).text());
                self.ratname = ko.observable($('<div/>').html(item.RAT_Name).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RAT_List_Model() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function ZATRAT_LowestLevel_Model(item) {
            try {
                var self = this;
                self.zatuid = ko.observable($('<div/>').html(item.ZAT_UID).text());
                self.ratuid = ko.observable($('<div/>').html(item.RAT_UID).text());
                self.LowestLevelFlag = ko.observable($('<div/>').html(item.Lowest_Level_Flag).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ZATRAT_LowestLevel_Model() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function AllAreaLevelModel(item) {
            try {
                var self = this;
                self.eal_uid = ko.observable($('<div/>').html(item.EAL_UID).text());
                self.eal_name = ko.observable($('<div/>').html(item.EAL_NAME).text());
                self.eal_short_name = ko.observable($('<div/>').html(item.EAL_SHORT_NAME).text());
                self.eal_description = ko.observable($('<div/>').html(item.EAL_DESCRIPTION).text());
                self.eal_level = ko.observable($('<div/>').html(item.EAL_LEVEL).text());
                self.eal_rat_names = ko.observable($('<div/>').html(item.RAT_NAMES).text());
                self.eal_zat_names = ko.observable($('<div/>').html(item.ZAT_NAMES).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AllAreaLevelModel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function ALLowestLevelModel(item) {
            try {
                var self = this;
                self.ratuid = ko.observable(item.ratuid);
                self.ratname = ko.observable(item.ratname);
                self.zatuid = ko.observable(item.zatuid);
                self.zatname = ko.observable(item.zatname);
                self.IsLowestLevel = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AllAreaLevelModel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function TvpLowestLevelModel(item) {
            try {
                var self = this;
                self.ZAT_UID = item.zatuid();
                self.RAT_UID = item.ratuid();
                self.Lowest_Level_Flag = item.IsLowestLevel();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TvpLowestLevelModel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function EalCategoryModel(item) {
            try {
                var self = this;
                self.Mat_UID = ko.observable(item.Mat_UID);
                self.Mat_Name = ko.observable(item.Mat_Name);
                self.Rat_ID = ko.observable(item.Rat_ID.trim());
                self.Zat_ID = ko.observable(item.ZAT_ID.trim());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EalCategoryModel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
        function EalSubCategoryDetailsModel(item) {
            try {
                var self = this;
                self.Mat_UID = ko.observable($('<div/>').html(item.Mat_UID).text());
                self.Mat_Name = ko.observable($('<div/>').html(item.Mat_Name).text());
                self.MAT_DESCRIPTION = ko.observable($('<div/>').html(item.MAT_Description).text());
                self.APPLICABILE_IDS = ko.observable($('<div/>').html(item.APPLICABILE_IDS).text());
                self.APPLICABILITY = ko.observable($('<div/>').html(item.APPLICABILITY).text());
                self.ZAT_IDS = ko.observable($('<div/>').html(item.ZAT_IDS).text());
                self.ZAT_NAMES = ko.observable($('<div/>').html(item.ZAT_NAMES).text());
                self.PARENT_AREA_IDS = ko.observable($('<div/>').html(item.PARENT_AREA_IDS).text());
                self.PARENT_AREA_NAMES = ko.observable($('<div/>').html(item.PARENT_AREA_NAMES).text());
                self.CalculationApplicabilityFlag = ko.observable(item.CalculationApplicabilityFlag);
                self.CalculationApplicabilityComponents = ko.observable($('<div/>').html(item.CalculationApplicabilityComponents).text()); 

                if (item.CalculationApplicabilityComponents)
                    self.ApplicabilityFlag = item.CalculationApplicabilityComponents;
                else
                    self.ApplicabilityFlag = "No";
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EalSubCategoryDetailsModel() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeAssessmentTypeSubArea(data, event) {
            try {

                ALViewModel.SelectedAssessmentTypeSubArea($("#RAApplicability").val());

                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeAssessmentTypeSubArea() method in RATaxonomySetup.js';
                logger.logMessage(msg);
            }
        }
    });
